// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__xO-Pt","header":"ReportDetails_header__3cay-","title":"ReportDetails_title__Gd9_7","left":"ReportDetails_left__1gKMx"};